(function(){
  /* Effet d'apparition au scroll désactivé : tout le contenu est visible immédiatement. */
  document.documentElement.classList.remove('orn-js');
  function showAll(){ document.querySelectorAll('.orn-rv').forEach(function(e){ e.classList.add('in'); }); }
  if (document.readyState !== 'loading') showAll(); else document.addEventListener('DOMContentLoaded', showAll);
  document.addEventListener('shopify:section:load', showAll);
})();
